export default __webpack_public_path__ + "images/ZY.27b6cba.png";